import { put, select, takeLatest } from 'redux-saga/effects'
import { getPCRDocsSelector } from '../selectors'
import { getFilterSelector } from '../selectors/getFilter.selector'
import { setFilteredPcrList } from '../store/home.actions'
import { HomeConstants } from '../store/home.constants'
import { IHomeFilterState, IPcrSummary, IPcrSummaries } from '../store/home.types'

export function* applyFilter() {
  const filterState: IHomeFilterState = yield select(getFilterSelector)
  const { incompleteFilterOn, completeFilterOn, needsReviewFilterOn } = filterState
  const pcrDocs: IPcrSummaries = yield select(getPCRDocsSelector)
  const filters: string[] = []
  incompleteFilterOn && filters.push('Incomplete')
  needsReviewFilterOn && filters.push('Needs Review')
  completeFilterOn && filters.push('Complete')
  if (filters && filters.length) {
    const filteredPCRDocs = pcrDocs.filter((pcrDoc: IPcrSummary) => filters.indexOf(pcrDoc.status) > -1)
    yield put(setFilteredPcrList(filteredPCRDocs))
  }
}

export function* applyFilterSaga() {
  yield takeLatest([HomeConstants.APPLY_FILTERS], applyFilter)
}
